/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./EmptyState.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Heading from '@atlaskit/heading';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { EmptyStateOld } from './EmptyStateOld';
var styles = {
  emptyState: "_zulpu2gc _4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1osq _1bah1h6o _18u01ejb _2hwx1ejb _y3gn1h6o",
  description: "_19pkze3t _otyr1ejb _syaz1fxt"
};
export var EmptyStateNew = function EmptyStateNew(_ref) {
  var testId = _ref.testId,
    header = _ref.header,
    description = _ref.description,
    renderImage = _ref.renderImage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.emptyState,
    testId: testId
  }, renderImage === null || renderImage === void 0 ? void 0 : renderImage(), /*#__PURE__*/React.createElement(Heading, {
    size: "small"
  }, header), description && /*#__PURE__*/React.createElement(Box, {
    as: "p",
    xcss: styles.description
  }, description));
};
export var EmptyState = function EmptyState(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(EmptyStateNew, props);
  }
  return /*#__PURE__*/React.createElement(EmptyStateOld, props);
};